import { useEffect } from 'react';
export var useUnmountEffect = function useUnmountEffect(fn) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return useEffect(() => () => fn(),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
};